/*
 * @Author: liujiang liujiang@shjinjia.com.cn
 * @Date: 2022-09-23 17:30:06
 * @LastEditors: wangqi angelqiqiwang@shjinjia.com.cn
 * @LastEditTime: 2024-08-21 15:47:52
 * @FilePath: \oak\src\store\modules\routerMap\views\warehouseManagement.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const map = {
  // 仓库管理
  dailyInventoryComparison: () =>
    import('@/views/warehouseManagement/DailyInventoryComparison'), // 保宏商品差异化处理
  inventoryMatchingRecord: () =>
    import('@/views/warehouseManagement/InventoryMatchingRecord'), // 库存匹配记录
  bHWarehouseAgeEnquiry: () =>
    import('@/views/warehouseManagement/BhWarehouseAgeEnquiry'), // 保宏仓库龄查询
  stockInOrderTableList: () =>
    import('@/views/warehouseManagement/StockInOrderTableList'), // 自贸达入库单插槽写的查询表格页面
  stockInOrder: () =>
    import('@/views/warehouseManagement/StockInOrder'), // 自贸达入库单插槽写的查看详情页
  stockOutOrderTableList: () =>
    import('@/views/warehouseManagement/StockOutOrderTableList'), // 自贸达出库单插槽写的查询表格页面
  stockOutOrderForm: () =>
    import('@/views/warehouseManagement/StockOutOrderForm'), // 自贸达出库单详情页面
  ztcStockInventorySkuTableList: () =>
    import('@/views/warehouseManagement/ZtcStockInventorySkuTableList'), // 在途仓库存
  ztcTransferIoCheckTableList: () =>
    import('@/views/warehouseManagement/ZtcTransferIoCheckTableList'), // 在途仓核对列表查询页面
  ztcTransferIoCheckForm: () =>
    import('@/views/warehouseManagement/ZtcTransferIoCheckForm'), // 在途仓核对详情页面
  ztcOtherOutOrderTableList: () =>
    import('@/views/warehouseManagement/ZtcOtherOutOrderTableList'), // 在途仓出库单页面
  ztcTransferInventoryDisposalTableList: () =>
    import('@/views/warehouseManagement/ZtcTransferInventoryDisposalTableList'), // 存货处理
  preStockinRepeatManagementTableList: () =>
    import('@/views/warehouseManagement/PreStockinRepeatManagementTableList'), // 预入库重复处理
  preStockinRegisterWriteoffManagementTableList: () =>
    import('@/views/warehouseManagement/PreStockinRegisterWriteoffManagementTableList'), // 预入库单登记核销管理
  oemGoodsListTableList: () =>
    import('@/views/warehouseManagement/OemGoodsListTableList'), // 库存计划
  warehouseStockConfig: () =>
    import('@/views/warehouseManagement/warehouseStockConfig'), // 库存状态
}

export default map
